import React from 'react';
import DecisionEngineBlock from '../../decision-engine/DecisionEngineBlock';
import DrawerFooterActions from './DrawerFooterActions';

function Row({ label, value }) {
  return (
    <li className="flex items-center justify-between text-sm">
      <span className="text-slate-500 dark:text-slate-400">{label}</span>
      <span className="font-black text-slate-900 dark:text-white">{value}</span>
    </li>
  );
}

export default function UserDetailDrawer({ entity, onClose }) {
  const snapshot = entity?.snapshot || {};
  const filters = entity?.filters || {};

  const activeUsers = Number(snapshot.activeUsers || 0);
  const paidUsers = Number((snapshot.paidUsers ?? snapshot.premiumUsers) || 0);
  const trialUsers = Number(snapshot.trialUsers || 0);
  const freeUsers = Number(snapshot.freeUsers || 0);
  const paidRate = activeUsers > 0 ? Number(((paidUsers / activeUsers) * 100).toFixed(2)) : 0;
  const confidence = activeUsers >= 100 ? 'YÜKSEK' : activeUsers >= 30 ? 'ORTA' : 'DÜŞÜK';
  const anomalies = [];
  if (activeUsers === 0 && (paidUsers > 0 || trialUsers > 0 || freeUsers > 0)) {
    anomalies.push('Aktif kullanıcı 0 iken alt kırılımlarda değer var; veri kaynağı tutarlılığı kontrol edilmeli.');
  }
  if (paidUsers > activeUsers) {
    anomalies.push('Ücretli kullanıcı sayısı toplam aktif kullanıcıdan yüksek görünüyor.');
  }
  if (paidRate > 90 && activeUsers >= 30) {
    anomalies.push('Ücretli oranı alışılmadık derecede yüksek; segment filtreleri doğrulanmalı.');
  }

  const actions = [
    'Ücretli oran düşükse bu kitleye uygun deneme/teklif akışını öne çıkar.',
    'Alerjanlı veya bebekli kullanıcı yoğunluğu yükseliyorsa güvenli tarif yüzeyini güçlendir.',
    'Aktif kullanıcı düşüşünde son 7 gün yüzey bazlı trafiği karşılaştır.'
  ];

  const priority = activeUsers >= 100 ? 'HIGH' : activeUsers >= 30 ? 'MEDIUM' : 'LOW';

  const handleExport = () => {
    const payload = {
      drawerKey: 'user',
      filters,
      snapshot
    };
    const blob = new Blob([JSON.stringify(payload, null, 2)], { type: 'application/json;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `kullanici-detay-${Date.now()}.json`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="space-y-4">
      <section className="rounded-lg border border-slate-200 bg-slate-50 p-3 dark:border-slate-800 dark:bg-slate-900">
        <p className="text-xs text-slate-500 dark:text-slate-400">Kullanıcı Özet Alanı</p>
        <h4 className="mt-1 text-lg font-black text-slate-900 dark:text-white">{activeUsers.toLocaleString('tr-TR')}</h4>
        <p className="text-sm text-slate-600 dark:text-slate-300">Aktif kullanıcı | Ücretli oranı: %{paidRate.toLocaleString('tr-TR')}</p>
      </section>

      <section className="rounded-lg border border-slate-200 bg-white p-3 dark:border-slate-800 dark:bg-slate-900/60">
        <p className="text-xs font-semibold text-slate-500 dark:text-slate-400">Kitle Kırılımı</p>
        <ul className="mt-2 space-y-1.5">
          <Row label="Ücretli" value={paidUsers.toLocaleString('tr-TR')} />
          <Row label="Deneme" value={trialUsers.toLocaleString('tr-TR')} />
          <Row label="Ücretsiz" value={freeUsers.toLocaleString('tr-TR')} />
          <Row label="Bebekli" value={Number(snapshot.babyUsers || 0).toLocaleString('tr-TR')} />
          <Row label="Alerjanlı" value={Number(snapshot.allergyUsers || 0).toLocaleString('tr-TR')} />
        </ul>
      </section>

      <section className="rounded-lg border border-slate-200 bg-white p-3 dark:border-slate-800 dark:bg-slate-900/60">
        <p className="text-xs font-semibold text-slate-500 dark:text-slate-400">Filtre Bağlamı</p>
        <ul className="mt-2 space-y-1.5">
          <Row label="Tarih penceresi" value={String(filters.window || '-')} />
          <Row label="Yüzey" value={String(filters.surface || 'tümü')} />
          <Row label="Bağlam" value={String(filters.context || 'tümü')} />
          <Row label="Segment" value={String(filters.segment || 'seçilmedi')} />
        </ul>
      </section>

      <DecisionEngineBlock
        narrative="Kullanıcı dağılımı, ücretli dengesi ve segment yoğunluğu birlikte okunarak hızlı aksiyon önceliği belirlenir."
        actions={actions}
        anomalies={anomalies}
        priority={priority}
        confidence={confidence}
        sampleSize={activeUsers}
        expectedOutcome="Doğru segment yüzeyi ile aktif kullanıcı dönüşümünde +1 ila +3 puan iyileşme hedeflenir."
      />

      <DrawerFooterActions onClose={onClose} onExport={handleExport} />
    </div>
  );
}
